<template>
    <div class="">
        <!-- region first: it also narrows the server names in the dropdown below -->
        <div class="flex justify-between flex-wrap items-center py-2">
            <div class="flex flex-wrap gap-2 py-2">
                <SearchBar :region="adminLicenseStore.region" @name-selected="nameSelectedHandeler">
                </SearchBar>
                <div v-if="selectedServerName !== ''" class="w-32 pr-5 text-xs">
                    Status
                    <v-select v-model="selectedLicenseStatus" :items="licenseStatusList" density="compact" rounded="0"
                        variant="outlined" placeholder="Select License Status"
                        style="padding-top: 0px;padding-bottom: 0px;">
                    </v-select>
                </div>
                <div v-if="selectedServerName !== ''" class="w-48 pr-5 text-xs">
                    Customer Email
                    <v-combobox v-model="selectedCustomerName" :items="customers" placeholder="Select" rounded="0"
                        variant="outlined" style="outline: none;" density="compact" :hide-no-data="false">
                        <template v-slot:no-data>
                            <v-list-item density>
                                <v-list-item-title density="compact" variant="disabled">
                                    <p class="text-sm text-gray-600 text-center">Not found</p>
                                </v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-combobox>
                </div>
                <div v-if="selectedServerName !== ''" class="w-32 pr-5 text-xs">
                    Expiring
                    <v-select v-model="selectedExpiringMode" :items="expiringModeList" density="compact" rounded="0"
                        variant="outlined" placeholder="Select Expiring Mode"
                        style="padding-top: 0px;padding-bottom: 0px;">
                    </v-select>
                </div>
                <div v-if="selectedServerName !== ''" class="w-36 pr-5 text-xs">
                    Sort Type
                    <v-select v-model="selectedSorting" :items="sortingModeList" density="compact" rounded="0"
                        variant="outlined" placeholder="Select Expiring Mode"
                        style="padding-top: 0px;padding-bottom: 0px;">
                    </v-select>
                </div>
            </div>
            <div v-if="selectedServerName !== ''">
                <v-btn size="small" style="outline: none;" title="Add a test license for a number of minutes"
                    class="mr-5 bg-dark text-light" data-bs-toggle="modal" data-bs-target="#licenseQuickAddModal"
                    @click="quickAddMode = 'test'">TEST</v-btn>
                <v-btn icon="mdi-plus" size="small" style="outline: none;" title="Add a license to a customer (any free port)"
                    class="mr-5 bg-dark text-light" data-bs-toggle="modal" data-bs-target="#licenseQuickAddModal"
                    @click="quickAddMode = 'normal'"></v-btn>
                <v-btn icon="mdi-delete" size="small" style="outline: none;" @click="deleteLicenses"
                    class="mr-5 bg-dark text-light"></v-btn>
            </div>
        </div>
        <!-- <div v-if="loading === true" class=" flex items-center h-[500px] justify-center" >
            <img src="../../../assets/loading.gif" class="w-[50px]"/>
        </div> -->
        <div v-if="loading === true" class=" flex items-center justify-center absolute custom-style " >
            <img src="../../../assets/loading.gif" class="w-[50px]"/>
        </div>
        <!-- desktop: the table -->
        <div class="hidden md:block">
        <v-data-table :headers="headers" :items="Licenses" item-key="name" items-per-page="-1" id="tablecontainer1" hide-default-footer
            class="border h-[500px] bg-white text-black min-h-[500px]" style="font-size: 13px;" :style="`height: ${computedHeight}px;`">
            
            <template #item="{ item, index }">
                
                <tr :class="{ 'text-red': item.status !== 'ACTIVE' }">
                    <td>{{ index + 1 }}</td>
                    <td>
                        <div @click="toggleSelection(item)" class="ml-auto align-self-center"
                            style="width: 20px; height: 20px; cursor: pointer;">

                            <input :checked="isSelected(item)" class="form-check-input shadow-none" type="checkbox" />
                        </div>
                    </td>
                    <td>
                        <div class="">
                            <div class="flex justify-between items-center bg-white px-3 py-1 text-black">
                            Server Online <v-icon icon="mdi-circle" size="15"
                                    :color="item.modem_conn_status ? 'green' : 'red'" class="mr-2"></v-icon>
                        </div>
                        <!-- ProxySmart only: amber when the port has as many live connections as its limit allows -->
                        <div class="flex justify-between items-center bg-white px-3 py-1 text-black" :title="connsTitle(item)">
                            {{ item.conn_limited ? 'Max conns' : 'Proxy Online' }} <v-icon icon="mdi-circle" size="15"
                                    :color="item.conn_limited ? 'amber-darken-2' : ((item.proxy_status === 'CONNECTED' && item.modem_conn_status) || (item.proxy_status === 'true' && item.modem_conn_status) ? 'green' : 'red')" class="mr-2"></v-icon>
                        </div>
                        <div v-if="item.conns_total != null" class="px-3 text-[11px]" :style="item.conn_limited ? 'color: #b8791f; font-weight: 600;' : 'color: var(--ui-dim);'">
                            {{ item.conns_total }} / {{ item.conn_limit }} conns
                        </div>
                        </div>
                    </td>
                    <td>
                        <div class="flex items-center">

                            {{ item.modem_name }}
                        </div>
                    </td>
                    <td class="text-center">
                        <div class="flex items-center justify-center">
                            {{ calculateRemainingTime(item.expired_date) }}
                            <v-icon icon="mdi-plus-circle-outline" color="green" size="18" class="ml-2" style="cursor: pointer;" title="Add time to this license"
                                data-bs-toggle="modal" data-bs-target="#licenseExtendModal" @click.stop="selectedItem = item"></v-icon>
                        </div>
                        <div>Start: {{ formatDate(new Date(item.start_date)) }}</div>
                        <div>Expire: {{ formatDate(new Date(item.expired_date)) }}</div>
                        <!-- {{ item.start_date.split('T')[0].replaceAll('-', '/') + `~` +
                    item.expired_date.split('T')[0].replaceAll('-', '/') }} -->
                    </td>
                    <td>
                        <v-icon icon="mdi-license" color="green"></v-icon>
                        {{ item.package_name }}
                    </td>
                    <td>
                        <!-- <v-icon icon="mdi-alpha-h-circle-outline" color="green"></v-icon> -->
                        HTTP: {{ item.proxy_http_port }} 
                        <br>
                        <!-- <v-icon icon="mdi-alpha-s-circle-outline" color="green"></v-icon> -->
                        SocksV5: {{ item.proxy_sock_port }}
                        <div v-if="item.modem_type === 'PROPROXYUI' && String(item.status).toUpperCase() === 'ACTIVE'" class="lic-vpn" :title="item.vpn?.wg_seen ? 'WireGuard last seen ' + new Date(item.vpn.wg_seen).toLocaleString() : ''">
                            <span><i class="lic-dot" :class="{ 'is-on': item.vpn?.wg_connected }"></i>WireGuard
                                <button type="button" class="lic-dl" title="Download the WireGuard file" @click.stop="downloadVpn(item, 'wg')"><v-icon icon="mdi-download" size="13"></v-icon></button></span>
                            <span><i class="lic-dot" :class="{ 'is-on': item.vpn?.ovpn_connected }"></i>OpenVPN<template v-if="item.vpn?.ovpn_sessions"> ×{{ item.vpn.ovpn_sessions }}</template>
                                <button type="button" class="lic-dl" title="Download the OpenVPN file" @click.stop="downloadVpn(item, 'ovpn')"><v-icon icon="mdi-download" size="13"></v-icon></button></span>
                        </div>
                    </td>
                    <td>
                        <!-- XPROXY_NEW: one combined port, one counter -->
                        <div class=" w-32 text-center" v-if="item.modem_type==='X_PROXY' && item.modem_variant==='v2'">
                            HTTP+SOCKS5: {{ item.http_dl_bytes ? item.http_dl_bytes : 0 }} MB
                        </div>
                        <div class=" w-28 text-center" v-else-if="item.modem_type==='X_PROXY'">
                            <div>
                                HTTP: 
                                {{ item.http_dl_bytes ? item.http_dl_bytes : 0 }} MB
                            </div>
                            <div>
                                SOCKS5:  
                                {{ item.sock_dl_bytes ? item.sock_dl_bytes : 0 }} MB
                            </div>
                        </div>
                        <div class=" w-28 text-center" v-else-if="item.modem_type==='PROXYSMART' || item.modem_type==='PROPROXYUI'">
                            <div>
                                {{ item.dl_bytes ? item.dl_bytes : '0MB' }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="w-32 mx-auto" @click="alert">
                            <div class="text-start flex items-center">
                                <v-icon icon="mdi-account-key" color="green mx-1"></v-icon>
                                {{ (item.auth_user === '' || item.auth_user === null) ? '- - - - - / - - - - - ' :
                    item.auth_user }}
                            </div>
                            <div class="text-start flex items-center">
                                <v-icon icon="mdi-ip" color="green mx-1"></v-icon>
                                <div>
                                    <div v-if="item.auth_ips === '' || item.auth_ips === null">
                                      - - - - - / - - - - -
                                    </div>
                                    <div v-else>
                                      <div v-for="(str, index) in item.auth_ips.split(',')" :key="index">
                                        {{ str }}<br />
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="w-[250px] mx-auto " @click="alert">
                            <div class="text-start flex items-center justify-center">
                                <v-icon icon="mdi-account" color="green  mx-1"></v-icon>
                                {{ item.customer_name }}
                            </div>
                            <div class="text-start flex items-center justify-center">
                                <v-icon icon="mdi-email" color="green  mx-1"></v-icon>
                                {{ item.customer_email }}
                            </div>
                        </div>
                    </td>
                    <td>
                        <v-menu offset-y location="bottom">
                            <template v-slot:activator="{ props, on, isActive }">
                                <v-btn v-bind="props" v-on="{ ...on }" density="compact"
                                    :style="isActive ? 'border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;' : ''"
                                    style="outline: none; font-size: 10px; " class="w-32 z-10 bg-dark text-light">
                                    Actions
                                    <v-icon icon="mdi-chevron-down" size="14"></v-icon>
                                </v-btn>
                            </template>
                            <v-list class="w-32 flex-1 flex flex-col px-0 py-0  z-0"
                                style="border-top-left-radius: 0px;border-top-right-radius: 0px">
                                <v-btn v-for="(button, index) in actionButtons" :key="index"
                                    @click="clickAction(item, button)" rounded="0" class="text-center bg-dark text-light "
                                    style="font-size: 10px; width: 128px; outline: none; border-bottom: 1px solid #345;"
                                    :data-bs-toggle="(button === 'Update'||button === 'Switch Modem'||button === 'IP History')&& 'modal'"
                                    :data-bs-target="
                                    button === 'Update'?'#licenseUpdateModal':
                                    button === 'Switch Modem'?'#modemChangeModal':
                                    button === 'IP History'?'#licenseIpChangeHistoryModal':
                                    ''"
                                    >{{
                    button }}</v-btn>
                            </v-list>
                        </v-menu>
                    </td>
                    <td>
                        <a v-if="item.tg_username" class="nav-link active" :href="`https://t.me/${item.tg_username}`" target="_blank">
                            @{{ item.tg_username }}
                        </a>
                    </td>
                    <td>{{ item.comment }}</td>
                    <td>{{ item.last_change_ip && item.last_change_ip.split('T')[0].replaceAll('-', '/') }}</td>
                    <td class="text-center">
                        {{ item.auto_rotation_time <= 0 ? 'Not defined' : item.auto_rotation_time + ' min' }} </td>
                </tr>
            </template>
            <template #bottom></template>
        </v-data-table>
        </div>
        <!-- Phone view (under 768 px): one card per licence, large text and thumb-sized buttons -->
        <div class="md:hidden space-y-3 pb-3 license-cards">
            <div v-if="!Licenses || Licenses.length === 0" class="text-center text-gray-500 py-6">No licences match the filter.</div>
            <div v-for="item in Licenses" :key="item.uuid" class="license-card rounded-lg border bg-white text-black p-3"
                :class="{ 'border-red-400': item.status !== 'ACTIVE' }">
                <div class="flex items-start justify-between gap-2">
                    <div class="min-w-0">
                        <div class="font-semibold text-[16px] break-all">{{ item.customer_email }}</div>
                        <div class="text-[14px] text-gray-600">{{ item.customer_name }}</div>
                    </div>
                    <div class="flex items-center gap-2 shrink-0">
                        <span class="text-[13px] flex items-center gap-1" title="Server / proxy online">
                            <v-icon icon="mdi-circle" size="14" :color="item.modem_conn_status ? 'green' : 'red'"></v-icon>
                            <v-icon icon="mdi-circle" size="14" :title="connsTitle(item)" :color="item.conn_limited ? 'amber-darken-2' : ((item.proxy_status === 'CONNECTED' || item.proxy_status === 'true') && item.modem_conn_status ? 'green' : 'red')"></v-icon>
                        </span>
                        <input :checked="isSelected(item)" @click="toggleSelection(item)" class="form-check-input shadow-none" type="checkbox" style="width: 22px; height: 22px;" />
                    </div>
                </div>
                <div class="mt-2 text-[15px]">
                    <div><span class="text-gray-500">Server</span> {{ item.modem_name }}</div>
                    <div><span class="text-gray-500">Package</span> {{ item.package_name }}</div>
                    <div><span class="text-gray-500">Ports</span> HTTP {{ item.proxy_http_port }} · SOCKS5 {{ item.proxy_sock_port }}</div>
                    <div><span class="text-gray-500">Auth</span> <span class="font-mono break-all">{{ item.auth_user || (item.ip_whitelist ? 'IP: ' + item.ip_whitelist : '-') }}</span></div>
                    <div><span class="text-gray-500">Download</span>
                        <template v-if="item.modem_type === 'X_PROXY' && item.modem_variant === 'v2'">{{ item.http_dl_bytes || 0 }} MB</template>
                        <template v-else-if="item.modem_type === 'X_PROXY'">HTTP {{ item.http_dl_bytes || 0 }} MB · SOCKS5 {{ item.sock_dl_bytes || 0 }} MB</template>
                        <template v-else>{{ item.dl_bytes || '0MB' }}</template>
                    </div>
                    <div :class="item.status === 'ACTIVE' ? 'text-green-600' : 'text-red-500'">
                        <span class="text-gray-500">Time</span> {{ calculateRemainingTime(item.expired_date) }}
                    </div>
                    <div class="text-[13px] text-gray-500">{{ formatDate(new Date(item.start_date)) }} → {{ formatDate(new Date(item.expired_date)) }}</div>
                </div>
                <div class="mt-3 grid grid-cols-3 gap-2">
                    <v-btn class="bg-dark text-light" height="42" @click="clickAction(item, 'Change IP')">Change IP</v-btn>
                    <v-btn class="bg-success text-light" height="42" data-bs-toggle="modal" data-bs-target="#licenseExtendModal" @click="selectedItem = item">Add time</v-btn>
                    <v-btn class="bg-dark text-light" height="42" data-bs-toggle="modal" data-bs-target="#licenseIpChangeHistoryModal" @click="clickAction(item, 'IP History')">History</v-btn>
                    <v-btn class="bg-dark text-light" height="42" data-bs-toggle="modal" data-bs-target="#licenseUpdateModal" @click="clickAction(item, 'Update')">Edit</v-btn>
                    <v-btn class="bg-dark text-light" height="42" data-bs-toggle="modal" data-bs-target="#modemChangeModal" @click="clickAction(item, 'Switch Modem')">Move</v-btn>
                    <v-btn class="bg-dark text-light" height="42" @click="clickAction(item, 'Copy Details')">Copy</v-btn>
                </div>
            </div>
        </div>
    </div>
    <div>
        <QuickAddLicenseDialog :customerEmail="selectedCustomerName" :mode="quickAddMode" @updated="updatedHandler" />
        <ExtendTimeDialog :item="selectedItem" @updated="updatedHandler" />
        <UpdateInfoDialog :item="selectedItem" @updated="updatedHandler"/>
        <ChangeModemDialog :selectedServerName="selectedServerName" :license_uuid="selectedItem?.uuid" :license="selectedItem"
            @updated="updatedHandler" />
        <IPChangeHistoryDialog :license="selectedItem" />
    </div>
</template>

<script setup>
import RegionTabs from '@/components/Common/RegionTabs.vue';
import { regionOf } from '@/helpers/region';
import { ref, defineProps, onMounted, onBeforeUnmount } from 'vue';
import { useAdminLicenseStore, useAdminProxyStore, useAlertStore } from "@/stores"
import { fetchWrapper } from '@/helpers';
import SearchBar from './SearchBar.vue';
import copy from "clipboard-copy"
import { storeToRefs } from 'pinia';

import QuickAddLicenseDialog from "./Modals/QuickAddLicenseDialog.vue"
import ExtendTimeDialog from "./Modals/ExtendTimeDialog.vue"
import UpdateInfoDialog from "./Modals/UpdateInfoDialog.vue"
import ChangeModemDialog from "./Modals/ChangeModemDialog.vue"
import IPChangeHistoryDialog from "./Modals/IPChangeHistoryDialog.vue"

import { watchEffect } from 'vue';
// ProProxyUI: download the customer's WireGuard / OpenVPN file
const downloadVpn = async (item, type) => {
    try {
        const f = await fetchWrapper.post(`${process.env.VUE_APP_VUE_API_URL}/admin/proproxyui/vpn-file`, { license_uuid: item.uuid, type });
        if (!f || !f.content) return;
        const a = document.createElement('a');
        a.href = URL.createObjectURL(new Blob([f.content], { type: 'application/octet-stream' }));
        a.download = f.filename;
        a.click();
        setTimeout(() => URL.revokeObjectURL(a.href), 5000);
    } catch (e) { useAlertStore().error(e); }
};
const props = defineProps({
    selectedEmail: {
        type: String, // Assuming user object has a name property
    },
});
const licenseStatusList = ref(['ACTIVE', 'EXPIRED', 'MAX CONNS'])   // MAX CONNS: active ProxySmart ports at their connection limit
// hover text: live connections on the port against its own limit (ProxySmart only)
const connsTitle = (item) => (item && item.conns_total != null && item.conn_limit)
    ? `${item.conns_total} of ${item.conn_limit} connections in use (HTTP ${item.conns_http ?? 0}, SOCKS5 ${item.conns_socks5 ?? 0})`
    : null;    
const selectedLicenseStatus = ref('ACTIVE')
const headers = ref(
    [
        { title: 'No', align: 'center', key: 'no' },
        { title: '', align: 'center', key: 'checkbox' },
        { title: 'Status', align: 'center', key: 'status' },
        { title: 'Modem', align: 'center', key: 'modem_name' },
        { title: 'Remaining/Start/Expire Time', align: 'center', key: 'date' ,minWidth: "250", width: "250" },
        { title: 'Package', align: 'center', key: 'package_name', minWidth: "200", width: "200" },
        { title: 'Proxy Ports', align: 'center', key: 'proxy_ports' , minWidth: "150", width: "150" },
        { title: 'Download', align: 'center', key: 'bytes' },
        { title: 'Auth', align: 'center', key: 'auth' },
        { title: 'Customer', align: 'center', key: 'customer' },
        { title: 'Actions', align: 'center', key: 'buttonBar' },
        { title: 'TG Username', align: 'center', key: 'tg_username'},
        { title: 'Comment', align: 'center', key: 'comment' },
        { title: 'IP Changed', align: 'center', key: 'last_change_ip' },
        { title: 'Auto Rotation Time', align: 'center', key: 'auto_rotation_time' },
    ]
);
const adminLicenseStore = useAdminLicenseStore()
adminLicenseStore.region = 'all'   // the page always opens on All
const { Licenses, loading } = storeToRefs(adminLicenseStore)

const selectedServerName = ref("All")
const quickAddMode = ref('normal')   // 'normal' (+ button) or 'test' (TEST button, minutes)
const updateInfoDialogFlag = ref(false)
const changeModemDialogFlag = ref(false)
const selectedItem = ref(null)
let count = 0;


const nameSelectedHandeler = (name) => {
    if (name && selectedServerName.value !== name) {
        selectedServerName.value = name
        adminLicenseStore.loadLicenses({
            serverName: name, 
            from: 0, 
            count: 50, 
            licenseStatus: selectedLicenseStatus.value, 
            expiringIn: selectedExpiringMode.value, 
            sortType: selectedSorting.value,
            customerName: selectedCustomerName.value})
        count = 50
    }
}


const actionButtons = ref(
    ["Update", "Change IP", "Switch Modem", "IP History", "Change history", "Copy Details", "Reboot"]
)
const clickAction = (item, button) => {
    switch (button) {
        case "Update":
            selectedItem.value = item
            updateInfoDialogFlag.value = true
            break
        case "Change IP":
            adminLicenseStore.changeIp(item.uuid)
            break;
        case "Reboot":
            adminLicenseStore.reboot(item.uuid)
            break;
        case "Switch Modem":
            selectedItem.value = item
            changeModemDialogFlag.value = true
            break;
        case "IP History":
            selectedItem.value = item
            break;
        case "Change history":   // Audit log for this licence, in a new tab
            window.open(`/admin/audit?entity_type=license&entity_id=${encodeURIComponent(item.uuid)}`, "_blank", "noopener")
            break;
        case "Copy Details":
            copyText(licenseDetails(item))
            break;

    }
}

// Copy details: HTTP and SOCKS5 on their own lines, then the rotation link
const licenseDetails = (item) => {
    const login = item.auth_user ? ':' + item.auth_user : ''
    return [
        `HTTP: ${item.host}:${item.proxy_http_port}${login}`,
        `SOCKS5: ${item.host}:${item.proxy_sock_port}${login}`,
        ...(item.rotation_link ? [`Rotation link: ${item.rotation_link}`] : []),
    ].join('\n')
}

const copyText = (text) => {
  copy(text)
  const alertStore = useAlertStore()
  alertStore.success("Copied");
}

const selectedItems = ref([]);

const isSelected = (item) => {
    return selectedItems.value.includes(item);
};

const toggleSelection = (item) => {
    const index = selectedItems.value.indexOf(item);
    if (index === -1) {
        selectedItems.value.push(item);
    } else {
        selectedItems.value.splice(index, 1);
    }
};

const deleteLicenses = () => {
    adminLicenseStore.deleteLicenses([...new Set(selectedItems.value.map(item => item.uuid))]).then(() => {   // each licence once
        adminLicenseStore.loadLicenses({
            serverName: selectedServerName.value, 
            from: 0, 
            count: 50, 
            licenseStatus: selectedLicenseStatus.value, 
            expiringIn: selectedExpiringMode.value, 
            sortType: selectedSorting.value,
            customerName: selectedCustomerName.value})
        count = 50
        selectedItems.value = []
    })

}
// All / UK / USA / Other: the list is paged by the server, so a tab change reloads the first page
const changeRegion = (key) => {
    adminLicenseStore.region = key
    // a chosen server outside the new region is deselected by the search bar, and that reloads the list
    const server = (useAdminProxyStore().serverNames || []).find((item) => item.name === selectedServerName.value)
    if (selectedServerName.value !== 'All' && key !== 'all' && (!server || regionOf(server.country) !== key)) return
    adminLicenseStore.loadLicenses({
        serverName: selectedServerName.value,
        from: 0,
        count: 50,
        licenseStatus: selectedLicenseStatus.value,
        expiringIn: selectedExpiringMode.value,
        sortType: selectedSorting.value,
        customerName: selectedCustomerName.value})
    count = 50
}
const updatedHandler = () => {
    updateInfoDialogFlag.value = false
    changeModemDialogFlag.value = false
    adminLicenseStore.loadLicenses({
        serverName: selectedServerName.value, 
        from: 0, 
        count: 50, 
        licenseStatus: selectedLicenseStatus.value, 
        expiringIn: selectedExpiringMode.value, 
        sortType: selectedSorting.value,
        customerName: selectedCustomerName.value})
    count = 50
}

const selectedCustomerName = ref(props.selectedEmail ? props.selectedEmail : "All")
const { customers } = storeToRefs(adminLicenseStore)

adminLicenseStore.getCustomers()

const expiringModeList = ref(['All', 'Expiring in 24 hours', 'Expiring in 7 days', 'Expiring in 30 days'])
const selectedExpiringMode = ref('All')
const sortingModeList = ref(["Start Date", "End Date"])
const selectedSorting = ref('Start Date')
// const searchString = ref('')
const offsetHeight = 300; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);

const handleResize = () => {
  computedHeight.value = window.innerHeight - offsetHeight;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
  const element = document.getElementById('tablecontainer1').children[0]
  element.addEventListener('scroll', onScroll)
  adminLicenseStore.loadLicenses({
    serverName: selectedServerName.value, 
    from: 0, 
    count: 50, 
    licenseStatus: selectedLicenseStatus.value, 
    expiringIn: selectedExpiringMode.value, 
    sortType: selectedSorting.value,
    customerName: selectedCustomerName.value})
  count = 50
});

let lastScrollLeft = 0;

const onScroll = (event) => {
  const table = event.target;
  if (table.scrollLeft !== lastScrollLeft) {
    lastScrollLeft = table.scrollLeft;
    return; // Ignore horizontal scroll
  }
  if (table.scrollTop + table.clientHeight >= table.scrollHeight) {
    adminLicenseStore.loadLicenses({
        serverName: selectedServerName.value, 
        from: count, 
        count: 20, 
        licenseStatus: selectedLicenseStatus.value, 
        expiringIn: selectedExpiringMode.value, 
        sortType: selectedSorting.value,
        customerName: selectedCustomerName.value})
    count += 20;
  }
};

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

// const getFilter = (license) => {
//     const diff = (new Date(license.expired_date) - new Date()) / (1000 * 60 * 60);
//     const expiringFlag = selectedExpiringMode.value === 'All' ?
//         true :
//         selectedExpiringMode.value === 'Expiring in 24 hours' ?
//             diff < 24 :
//             selectedExpiringMode.value === 'Expiring in 7 days' ?
//                 diff < 24 * 7 :
//                 selectedExpiringMode.value === 'Expiring in 30 days' ?
//                     diff < 24 * 30 :
//                     false
//     return (license.status.toUpperCase() === selectedLicenseStatus.value.toUpperCase()) &&
//         (selectedCustomerName.value === 'All' || license.customer_email.toUpperCase().includes(selectedCustomerName.value.toUpperCase())) &&
//         (license.uuid.includes(searchString.value) || license.proxy_http_port.toString().includes(searchString.value) || license.proxy_sock_port.toString().includes(searchString.value)) &&
//         expiringFlag
// }

const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year}  ${hours}:${minutes}:${seconds}`;
}

// watchEffect(() => {
//     if (selectedServerName.value !== '') {
//         Licenses.value = []
//     }
// }, [selectedServerName.value])

watchEffect(() => {
    adminLicenseStore.loadLicenses({
        serverName: selectedServerName.value, 
        from: 0, 
        count: 50, 
        licenseStatus: selectedLicenseStatus.value, 
        expiringIn: selectedExpiringMode.value, 
        sortType: selectedSorting.value,
        customerName: selectedCustomerName.value})
    count = 50
})

const calculateRemainingTime = (expiringTime) => {
    const now = new Date();
    const expirationDate = new Date(expiringTime);
    const timeDifference = expirationDate.getTime() - now.getTime();
    if(timeDifference<0){
        return "Expired"
    }
    // Convert milliseconds to days, hours, minutes, and seconds
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const str = (days ? `${days} Days, ` : '') +
        (hours ? `${hours} Hours, ` : '') +
        (minutes ? `${minutes} Mins ` : '')
    return str
}
</script>

<style scoped>
.lic-vpn { display: flex; flex-direction: column; gap: 1px; margin-top: 3px; font-size: 11.5px; white-space: nowrap; }
.lic-dl { margin-left: 4px; padding: 0 3px; border: 1px solid #22c55e; border-radius: 5px; color: #22c55e; background: transparent; line-height: 14px; cursor: pointer; }
.lic-dl:hover { background: rgba(34, 197, 94, 0.12); }
.lic-dot { display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 4px; background: #ef4444; }
.lic-dot.is-on { background: #22c55e; }
@media only screen and (max-width: 767px) {
  /* phone: filters two per row, full-width selects */
  .flex.flex-wrap.gap-2.py-2 > div { width: 48% !important; padding-right: 0 !important; font-size: 13px; }
  .license-card .v-btn { font-size: 13px; padding: 0 4px; }
}
.custom-style {
    width: -webkit-fill-available; /* Safari/WebKit */
    height: -webkit-fill-available; /* Safari/WebKit */
    width: -moz-available; /* Firefox */
    height: -moz-available; /* Firefox */
    width: fill-available; /* Standard syntax, for future compatibility */
    height: fill-available; /* Standard syntax, for future compatibility */
}
</style>
